import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";

export type FormValuesKey = keyof IntegrationFormData;

interface IlertFormProps {
  serverErrors?: ServerErrors;
}

export const IlertForm = ({serverErrors}: IlertFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <>
      <div className="row row-cols-2 mb-3">
        <div className="col-12 mb-3">
          <InputField
            name="settings.postback_url"
            label="Webhook URL"
            required={true}
            tooltip="The ilert endpoint URL where alert details will be sent via HTTP POST."
            autoFocus={true}
          />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          Instructions for setting up your webhook URL may be found at{" "}
          <a href="https://docs.ilert.com/integrations/inbound-integrations/uptime" target="_blank">
            https://docs.ilert.com/integrations/inbound-integrations/uptime
          </a>
        </div>
        <div className="p-2">
          <a target="_blank" href="https://support.uptime.com/hc/en-us/articles/26816020589980-Configuring-ilert">
            View {IntegrationModuleInfo[IntegrationModules.ILERT].label} Support Article &rarr;
          </a>
        </div>
      </SetupInfo>
    </>
  );
};
